export default __webpack_public_path__ + "static/media/brown-darken-historical.aa7dfdeb.svg";